import { permitir_consultar_matricula_diaria_por_ensino } from "./permitir-consultar-matricula-diaria-por-ensino/permitir-consultar-matricula-diaria-por-ensino";
import { emitir_relatório_de_matricula_diaria_por_escola_ensino } from "./emitir-relatorio-de-matricula-diaria-por-escola-ensino/emitir-relatorio-de-matricula-diaria-por-escola-ensino";
import { manutencao_de_visao_de_ensino } from "./manutencao-de-visao-de-ensino/manutencao-de-visao-de-ensino";
const retrato_de_matricula_diaria = [
  permitir_consultar_matricula_diaria_por_ensino,
  emitir_relatório_de_matricula_diaria_por_escola_ensino,
  manutencao_de_visao_de_ensino,
];

export { retrato_de_matricula_diaria };
